import React from 'react';
import { Sparkles } from 'lucide-react';

// Floating soap-bubble clipart layer
export const Bubbles = ({ count = 6, className = '' }) => {
  const bubbles = React.useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        left: `${8 + Math.random() * 84}%`,
        size: 8 + Math.random() * 22,
        delay: `${Math.random() * 5}s`,
        duration: `${4 + Math.random() * 4}s`,
        bottom: `${Math.random() * 30}%`,
      })),
    [count]
  );
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {bubbles.map((b, i) => (
        <span
          key={i}
          className="bubble"
          style={{
            left: b.left,
            bottom: b.bottom,
            width: b.size,
            height: b.size,
            animationDelay: b.delay,
            animationDuration: b.duration,
          }}
        />
      ))}
    </div>
  );
};

// Twinkling sparkle accents
export const SparkleAccents = () => (
  <>
    <Sparkles className="absolute top-3 right-4 h-5 w-5 text-[#f5b400] sparkle-twinkle" />
    <Sparkles
      className="absolute bottom-6 left-3 h-4 w-4 text-primary sparkle-twinkle"
      style={{ animationDelay: '0.8s' }}
    />
    <Sparkles
      className="absolute top-1/2 right-6 h-3.5 w-3.5 text-[#1a66c9] sparkle-twinkle"
      style={{ animationDelay: '1.6s' }}
    />
  </>
);

// glow class picker based on product id/category
export const glowClass = (product) => {
  if (product?.id?.includes('ocean') || product?.id?.includes('toilet') || product?.id?.includes('glass'))
    return 'glow-pedestal-blue';
  if (product?.id?.includes('aloevera') || product?.id?.includes('dish')) return 'glow-pedestal-yellow';
  return 'glow-pedestal';
};
